export const dashboardLayout = {
  sidebarWidth: 224,
  collapsedSidebarWidth: 72,
  settingsSidebarWidth: 210,
  headerHeight: 64,
  pageMaxWidth: 1600,
  formMaxWidth: 880,
  pagePadding: { xs: 2, md: 3.5 },
} as const;
